import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import ManagementTeamImage from "src/modules/3rd-party-management/assets/images/management-team.svg";
import { Table } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';
import {
    formatRole,
    hasNonEmptyArray,
    parseHandelsregisterOrganizationData
} from "../../helpers";

const RelatedPersons = ({
    t,
    activeAccordion,
    setActiveAccordion,
    detailsQuery
}) => {
    const dateUtils = new DateUtils();
    const data = parseHandelsregisterOrganizationData(detailsQuery?.data?.company);
    const current = data?.related_persons?.current || [];
    const past = data?.related_persons?.past || [];

    if (!hasNonEmptyArray(current) && !hasNonEmptyArray(past)) {
        return null;
    }

    const formatDate = (value) => (
        value ? dateUtils.convertDateToDate(value, INTERNATIONAL_DATE_FORMAT) : '-'
    );

    const renderRows = (people) => people.map((person, index) => (
        <tr key={person.entity_id || `${person.name}-${index}`}>
            <td>{person.name || '-'}</td>
            <td>{formatRole(person)}</td>
            <td>{formatDate(person.birth_date)}</td>
            <td>{person.location?.home?.city || '-'}</td>
            <td>{formatDate(person.start_date)}</td>
            <td>{formatDate(person.end_date)}</td>
        </tr>
    ));

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('related-persons')}
            className={activeAccordion === 'related-persons' ? 'active' : ''}
            eventKey={'related-persons'}
        >
            <Accordion.Header>
                <img src={ManagementTeamImage} alt="" />
                <span>{t('Management / Related Persons')}</span>
            </Accordion.Header>

            <Accordion.Body>
                {hasNonEmptyArray(current) && (
                    <div className="mb-4">
                        <h6 className="mb-3">{t('Current')}</h6>
                        <div className="table-responsive">
                            <Table bordered hover striped size="sm" className="mb-0">
                                <thead>
                                    <tr>
                                        <th>{t('Name')}</th>
                                        <th>{t('Role')}</th>
                                        <th>{t('Date of Birth')}</th>
                                        <th>{t('City')}</th>
                                        <th>{t('From')}</th>
                                        <th>{t('To')}</th>
                                    </tr>
                                </thead>
                                <tbody>{renderRows(current)}</tbody>
                            </Table>
                        </div>
                    </div>
                )}

                {hasNonEmptyArray(past) && (
                    <div>
                        <h6 className="mb-3">{t('Past')}</h6>
                        <div className="table-responsive">
                            <Table bordered hover striped size="sm" className="mb-0">
                                <thead>
                                    <tr>
                                        <th>{t('Name')}</th>
                                        <th>{t('Role')}</th>
                                        <th>{t('Date of Birth')}</th>
                                        <th>{t('City')}</th>
                                        <th>{t('From')}</th>
                                        <th>{t('To')}</th>
                                    </tr>
                                </thead>
                                <tbody>{renderRows(past)}</tbody>
                            </Table>
                        </div>
                    </div>
                )}
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default withNamespaces()(RelatedPersons);
